import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import styled from 'styled-components';

const Nav = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 80px;
  background: rgba(10, 10, 10, 0.95);
  backdrop-filter: blur(10px);
  border-bottom: 2px solid #00ff88;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2rem;
`;

const Logo = styled(Link)`
  font-size: 1.8rem;
  font-weight: bold;
  color: #00ff88;
  text-decoration: none;
  text-shadow: 0 0 10px #00ff88;
  
  &:hover {
    color: #00cc6a;
    text-shadow: 0 0 15px #00cc6a;
  }
`;

const NavLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 2rem;

  @media (max-width: 768px) {
    display: none;
  }
`;

const NavLink = styled(Link)`
  color: #ffffff;
  text-decoration: none;
  font-weight: 500;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    color: #00ff88;
    background: rgba(0, 255, 136, 0.1);
  }

  &.active {
    color: #00ff88;
    background: rgba(0, 255, 136, 0.2);
    box-shadow: 0 0 10px rgba(0, 255, 136, 0.3);
  }

  &::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 50%;
    width: 0;
    height: 2px;
    background: #00ff88;
    transition: all 0.3s ease;
    transform: translateX(-50%);
  }

  &:hover::after,
  &.active::after {
    width: 80%;
  }
`;

const MobileMenuButton = styled.button`
  display: none;
  background: none;
  border: none;
  color: #ffffff;
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.5rem;

  @media (max-width: 768px) {
    display: block;
  }
`;

const MobileMenu = styled.div`
  display: none;
  position: fixed;
  top: 80px;
  left: 0;
  right: 0;
  background: rgba(10, 10, 10, 0.98);
  backdrop-filter: blur(10px);
  border-bottom: 2px solid #00ff88;
  padding: 1rem;
  flex-direction: column;
  gap: 1rem;

  &.open {
    display: flex;
  }

  @media (max-width: 768px) {
    display: ${props => props.isOpen ? 'flex' : 'none'};
  }
`;

const MobileNavLink = styled(Link)`
  color: #ffffff;
  text-decoration: none;
  font-weight: 500;
  padding: 1rem;
  border-radius: 8px;
  transition: all 0.3s ease;

  &:hover {
    color: #00ff88;
    background: rgba(0, 255, 136, 0.1);
  }

  &.active {
    color: #00ff88;
    background: rgba(0, 255, 136, 0.2);
  }
`;

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <Nav>
        <Logo to="/" onClick={closeMobileMenu}>
          Skylink
        </Logo>
        
        <NavLinks>
          <NavLink to="/" className={location.pathname === '/' ? 'active' : ''}>
            Home
          </NavLink>
          <NavLink to="/signin" className={location.pathname === '/signin' ? 'active' : ''}>
            Sign In
          </NavLink>
          <NavLink to="/signup" className={location.pathname === '/signup' ? 'active' : ''}>
            Sign Up
          </NavLink>
          <NavLink to="/inmate-signup" className={location.pathname === '/inmate-signup' ? 'active' : ''}>
            Create Inmate Account
          </NavLink>
          <NavLink to="/connect-to-inmate" className={location.pathname === '/connect-to-inmate' ? 'active' : ''}>
            Connect to Inmate
          </NavLink>
          <NavLink to="/load-money" className={location.pathname === '/load-money' ? 'active' : ''}>
            Load Money
          </NavLink>
          <NavLink to="/dashboard" className={location.pathname === '/dashboard' ? 'active' : ''}>
            Dashboard
          </NavLink>
          <NavLink to="/profile" className={location.pathname === '/profile' ? 'active' : ''}>
            Profile
          </NavLink>
        </NavLinks>

        <MobileMenuButton onClick={toggleMobileMenu}>
          ☰
        </MobileMenuButton>
      </Nav>

      <MobileMenu isOpen={isMobileMenuOpen}>
        <MobileNavLink 
          to="/" 
          className={location.pathname === '/' ? 'active' : ''}
          onClick={closeMobileMenu}
        >
          Home
        </MobileNavLink>
        <MobileNavLink 
          to="/signin" 
          className={location.pathname === '/signin' ? 'active' : ''}
          onClick={closeMobileMenu}
        >
          Sign In
        </MobileNavLink>
        <MobileNavLink 
          to="/signup" 
          className={location.pathname === '/signup' ? 'active' : ''}
          onClick={closeMobileMenu}
        >
          Sign Up
        </MobileNavLink>
        <MobileNavLink 
          to="/inmate-signup" 
          className={location.pathname === '/inmate-signup' ? 'active' : ''}
          onClick={closeMobileMenu}
        >
          Create Inmate Account
        </MobileNavLink>
        <MobileNavLink 
          to="/connect-to-inmate" 
          className={location.pathname === '/connect-to-inmate' ? 'active' : ''}
          onClick={closeMobileMenu}
        >
          Connect to Inmate
        </MobileNavLink>
        <MobileNavLink 
          to="/load-money" 
          className={location.pathname === '/load-money' ? 'active' : ''}
          onClick={closeMobileMenu}
        >
          Load Money
        </MobileNavLink>
        <MobileNavLink 
          to="/dashboard" 
          className={location.pathname === '/dashboard' ? 'active' : ''}
          onClick={closeMobileMenu}
        >
          Dashboard
        </MobileNavLink>
        <MobileNavLink 
          to="/profile" 
          className={location.pathname === '/profile' ? 'active' : ''}
          onClick={closeMobileMenu}
        >
          Profile
        </MobileNavLink>
      </MobileMenu>
    </>
  );
};

export default Navbar; 